export async function getBrand(payload, thunkApi) {
  try {
    const { product } = thunkApi.extra.apiService;
    const { source } = payload;
    const response = await product.get(`/brand/all?source=${source}`);

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getSubCategory(payload, thunkApi) {
  try {
    const { product } = thunkApi.extra.apiService;
    const { source } = payload;
    const response = await product.get("/sub_category?source=" + source);

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getLocation(payload, thunkApi) {
  try {
    const { product } = thunkApi.extra.apiService;
    const { source } = payload;
    const response = await product.get("/location/all?source="+source);

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getDateRange(_, thunkApi) {
  try {
    const { product } = thunkApi.extra.apiService;

    const response = await product.get("/date-range");

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}
